import { EditPage, EditPageTextField, EditPageCheckbox, EditPageSelect, EditPagePanel } from './../../../common/EditPage';
import { create, getOne } from './../../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

const InvoiceTemplateCreate = () => {
    const navigate = useNavigate();
    const [data, setData] = useState({
        name: '',
        description: '',
        template: 'carrier_invoice',
        include_link_to_usage: false
    });
    const [metadata, setMetadata] = useState({});

    useEffect(() => {
        getOne('/admin/settings/invoice_templates/', 'new').then(response => {
            setMetadata(response.data.metadata);
        });
    }, []);

    const handleSave = () => {
        create('/admin/settings/invoice_templates', {data: data}).then(response => {
            toast.success("Invoice template created successfully", {});
            navigate('/settings/invoice_templates');
        }).catch(error => {
            toast.error("Error creating invoice template: " + error.message, {});
        });
    }
    const handleCancel = () => {
        navigate('/settings/invoice_templates');
    }
    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }
    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title="Create Invoice Template" >
                <EditPagePanel>
                    <EditPageTextField label="Name" id="name" onChange={ onChange } value={ data.name } />
                    <EditPageTextField label="Description" id="description" onChange={ onChange } value={ data.description } />
                    <EditPageSelect label="Template Type" id="template" onChange={ onChange } value={ data.template } options={ metadata?.template_types?.values } />
                    <EditPageCheckbox label="Include Link to Usage" id="include_link_to_usage" onChange={ onChange } value={ data.include_link_to_usage } />
                </EditPagePanel>
            </EditPage>
        </div>
    )
}

export default InvoiceTemplateCreate;